export default ({color, size}) =>
  <svg xmlns="http://www.w3.org/2000/svg"  width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
       className="toggle-dark-mode-mobile-icon moon svg replaced-svg">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
  </svg>
;
